<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="390"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        dark
        v-on="on"
      >
        Grant Admin
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="headline">{{title}}</v-card-title>
      <v-card-text>
        <v-col cols="12">
          <v-form
            ref="form"
            v-model="adminvalid"
          >
            <v-text-field
              v-model='email'
              :rules="emailRules"
              label="email"
              hint="Enter the email of the user"
            ></v-text-field>
          </v-form>
        </v-col>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn
          color="green darken-1"
          text
          @click="dialog = false"
        >Cancel</v-btn>
        <v-btn
          color="green darken-1"
          :disabled='!adminvalid'
          text
          @click="grantAdmin(),dialog = false"
        >Send</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { postReq } from '../../helper/firestore'
import { mapFields } from 'vuex-map-fields';
export default {
  props: {
    userType: String,
  },
  computed: {
    ...mapFields([
      'user',
      'snackBarshow',
      'snackBarType',
      'snackBarmessage',
    ]),
    title () {
      let title = "Grant Admin"
     
      return title
    },
  },
  methods: {
    grantAdmin () {
      postReq(process.env.VUE_APP_ROOT_API_URL + 'api/admin/grantadminMaster', { email : this.email}, result => {
        this.snackBarType = "success"
        this.snackBarshow = true
        this.snackBarmessage = result.data
        this.adminUser.email = ""
        this.adminUser.displayName = ""
        })}
  },
  data () {
    return {
      dialog: false,
      adminvalid: false,
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
     email : '',
    }
  }
}
</script>

<style>
</style>
